import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { ExportButton } from '../shared/ExportButton';

interface FiveWhyHeaderProps {
    incidentId?: string;
    incident: any;
}

export const FiveWhyHeader: React.FC<FiveWhyHeaderProps> = ({ incidentId, incident }) => {
    return (
        <div className="mb-6">
            {incidentId && (
                <Link
                    to={`/fracas/${incidentId}`}
                    className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4"
                >
                    <ArrowLeft className="w-4 h-4" />
                    Back to incident
                </Link>
            )}

            <h1 className="text-3xl font-bold text-gray-900 mb-2">5-Why Analysis</h1>
            <p className="text-gray-600">
                Drill down to the root cause by asking "Why?" up to 5 times
            </p>

            {incident && (
                <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                    <p className="text-sm font-medium text-blue-900">
                        Linked to: {incident.fracasNumber} - {incident.title}
                    </p>
                </div>
            )}

            <div className="mt-4 flex justify-end">
                <ExportButton
                    elementId="five-why-diagram"
                    fileName={`5Why_Analysis_${incident?.fracasNumber || 'new'}`}
                    title="5-Why Root Cause Analysis"
                    formats={['png', 'pdf']}
                />
            </div>
        </div>
    );
};
